import md5 from 'js-md5'
import { raygun } from '@ynap/clientside-monitoring'

export const FraudnetLoader = async (flowId, userEmail) => {
    const paypalClientMetadataId = md5(`${userEmail}${Date.now()}`)

    // "fnparams" Configuration JSON
    let script = document.createElement('script')
    script.type = 'application/json'
    let fncls = document.createAttribute('fncls')
    fncls.value = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99'
    script.attributes.setNamedItem(fncls)
    script.text = `{ "f": "${paypalClientMetadataId}", "s": "${flowId}"}`
    document.body.appendChild(script)

    const loadFraudnet = (options) => {
        return new Promise(function (resolve, reject) {
            let script = document.createElement('script')
            script.src = options.fnUrl
            script.onload = resolve
            script.onerror = reject
            document.body.appendChild(script)
        })
    }

    return loadFraudnet({ fnUrl: 'https://c.paypal.com/da/r/fb.js' })
        .then(() => {
            return paypalClientMetadataId
        })
        .catch((error) => {
            raygun.helpers.agent('send', { error, tags: ['checkout', 'paypal', 'fraudnet'] })
        })
}

export const getFraudnetFingerprint = async (flowId, userEmail) => {
    return await FraudnetLoader(flowId, userEmail)
}
